import VideoHlroomAnalytics from '@sky-it-video/hlroom-analytics';

const appType = 'tg24';

export const getIndexesFromHash = (hash: string, subSections?: any[]): [number, number?] => {
  const [subSectionTag, subSubSectionTag] = hash.replace('#', '').split('_');
  const subSectionIndex = subSections?.findIndex((subSection: any) => subSection.tag === subSectionTag);
  if (subSectionIndex && subSectionIndex >= 0) {
    const subSubSectionIndex = subSections?.[subSectionIndex].subSubSections?.findIndex(
      (subSubSection: any) => subSubSection.tag === subSubSectionTag
    );
    if (subSubSectionIndex >= 0) {
      return [subSectionIndex, subSubSectionIndex];
    } else {
      return [subSectionIndex];
    }
  } else {
    return [0];
  }
};

export const createOnSubSectionChange = (setHash: (hash: string) => void) => (subSection: any) => {
  VideoHlroomAnalytics.cleanUrlFromQueryParams('intcmp');
  VideoHlroomAnalytics.setDigitalData({ intcmp: '' }, appType);
  const tag = subSection.tag || '';
  setHash(tag);
  if (subSection.tag) {
    VideoHlroomAnalytics.setDigitalData({ pageName: { subSection: subSection?.tag as string } }, appType);
  }
  VideoHlroomAnalytics.analyticsTrack(VideoHlroomAnalytics.CONFIGS.tg24.PAGE);
};

export const getSubSectionFromHash = (hash: string): string | null => {
  const [subSection] = hash.replace('#', '').split('_');

  if (`#${subSection}` !== hash) {
    return subSection;
  } else {
    return null;
  }
};

export const getTagsFromHash = (hash: string) => {
  return hash.replace('#', '').split('_');
};

export const createOnSubSubSectionChange =
  (setHash: (newHash: string) => void, prevHash: string) => (subSubSection: any) => {
    VideoHlroomAnalytics.cleanUrlFromQueryParams('intcmp');
    VideoHlroomAnalytics.setDigitalData({ intcmp: '' }, appType);
    const [subSection] = prevHash.split('_');
    if (!subSubSection) {
      setHash(subSection);
      // FIXME we need to call setDigitalData here???
    } else {
      VideoHlroomAnalytics.setDigitalData({ pageName: { subSection, subSubSection: subSubSection.tag } }, appType);
      VideoHlroomAnalytics.analyticsTrack(VideoHlroomAnalytics.CONFIGS.tg24.PAGE);
      setHash([subSection, subSubSection.tag].join('_'));
    }
  };

export const createCreateLoadMoreFn =
  (setPage: (value: ((prevState: number) => number) | number) => void) =>
  (videosTotal: number, videosLength: number) =>
  (videosLimit?: number, videosStep?: number) => {
    if (typeof videosLimit !== 'undefined' && typeof videosStep !== 'undefined') {
      if (videosLimit + videosStep >= videosLength && videosLength < videosTotal) {
        setPage((curPage: number) => curPage + 1);
      }
    } else if (videosLength < videosTotal) {
      setPage((curPage: number) => curPage + 1);
    }
  };
